var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('span',{staticClass:"wrapper_name"},[_vm._v(_vm._s(_vm.title))]),_c('el-button',{staticClass:"wrapper_btn",attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.$emit('onBtnClick')}}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }